import { Theme } from 'studio-components/shared/types/theme.type';

export enum PopupNotificationType {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}

export type PopupNotificationData = {
  theme: Theme;
  type: PopupNotificationType;
  title: string;
  description?: string;
};
